export type BuyerReview = {
  /** Full name as the buyer agreed to show it (e.g. "Laura M."). */
  name: string
  /** e.g. "Head coach, Learn to Skate" */
  role: string
  /** Club, rink or city. */
  location: string
  /** Their words, verbatim. */
  quote: string
  /** Full URL to a photo of the buyer, used with their permission. */
  photo: string
  /** Optional 1–5 star rating they actually gave. Omit if they didn't rate. */
  rating?: number
}

/**
 * EMPTY ON PURPOSE (pre-launch). The "Coaches using it" section and the faces
 * in the hero stay hidden until at least one real review is added here.
 * Only add real buyers, with written permission for their name, words and
 * photo — US FTC rules prohibit fabricated or AI-generated reviews.
 *
 * The first review is shown as the featured one. Example shape:
 * {
 *   name: 'Laura M.',
 *   role: 'Head coach, Learn to Skate',
 *   location: 'Riverside Ice Club, Ohio',
 *   quote: 'Exactly what she wrote, word for word.',
 *   photo: 'https://…/laura.jpg',
 *   rating: 5,
 * },
 */
export const buyerReviews: BuyerReview[] = []
